import React from 'react'
import TelInput from '../base/TelInput'

const PrimaryTelInput = props => <TelInput {...props} />

export default PrimaryTelInput
